import React, {
  useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import {
  Tabs,
} from 'antd';
import PropTypes from 'prop-types';

import CustomModal from '../../common/modals/CustomModal';
import OntraccrButton from '../../common/buttons/OnTraccrButton';
import {
  updateShortList,
  deleteShortList,
} from '../state/boards.actions';
import CustomConfirmModal from '../../common/modals/CustomConfirmModal';
import ShortListCategoryTab from './ShortListCategoryTab';
import ShortListPermissionsTab from './ShortListPermissionsTab';
import ShortListDisplayFieldTab from './ShortListDisplayFieldTab';
import OnTraccrConfirmTextInput from '../../common/inputs/OnTraccrConfirmTextInput';

const { TabPane } = Tabs;

export default function ShortListSettingsModal({
  visible,
  onClose,
  shortList = {},
  onDelete,
  fieldOptions,
  fieldMap,
}) {
  const dispatch = useDispatch();

  const onConfirm = useCallback((inputValue) => {
    dispatch(updateShortList(shortList.id, { name: inputValue }));
  }, [shortList]);

  const onDeleteShortList = useCallback(() => {
    CustomConfirmModal({
      title: 'Delete Short List',
      content: 'Are you sure you want to delete this short list?',
      onOk: async () => {
        const res = await dispatch(deleteShortList(shortList.id));
        if (res) {
          onDelete();
          onClose();
        }
      },
      zIndex: 5000,
    });
  }, [shortList, onDelete, onClose]);

  return (
    <CustomModal
      visible={visible}
      onCloseClicked={onClose}
      title={`${shortList.name} Settings`}
      width={600}
    >
      <div>
        <OnTraccrConfirmTextInput value={shortList?.name} onConfirm={onConfirm} type="Name" />
        <Tabs tabBarStyle={{ paddingLeft: 10, paddingRight: 10 }}>
          <TabPane tab="Categories" key="categories">
            <ShortListCategoryTab shortList={shortList} />
          </TabPane>
          <TabPane tab="Permissions" key="permissions">
            <ShortListPermissionsTab shortList={shortList} />
          </TabPane>
          <TabPane tab="Display Fields" key="displayFields">
            <ShortListDisplayFieldTab
              shortList={shortList}
              fieldOptions={fieldOptions}
              fieldMap={fieldMap}
            />
          </TabPane>
        </Tabs>
      </div>
      <OntraccrButton
        title="Delete Short List"
        onClick={onDeleteShortList}
        style={{ marginTop: 10, marginBottom: 10 }}
        type="back"
      />
    </CustomModal>
  );
}

ShortListSettingsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  shortList: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onDelete: PropTypes.func.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  fieldMap: PropTypes.objectOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  })).isRequired,
};

ShortListSettingsModal.defaultProps = {
  shortList: {},
};
